import { combineReducers } from "redux"

import clusters from "./cluster-paging-reducer"
import communities from "./community-paging-reducer"
import communityParticipants from "./community-participants-paging-reducer"
import dimensionCount from "./dimension-count-reducer"
import dimensions from "./dimension-paging-reducer"
import feed from "./feed-paging-reducer"
import knowledge from "./knowledge-paging-reducer"
import knowledgeData from "./knowledge-data-paging-reducer"
import maps from "./map-paging-reducer"
import moderationFeed from "./moderation-feed-paging-reducer"
import notifications from "./notification-paging-reducer"
import projects from "./project-paging-reducer"
import reports from "./report-paging-reducer"
import roles from "./role-paging-reducer"
import sessions from "./session-paging-reducer"
import sources from "./source-paging-reducer"
import stakeholders from "./stakeholder-paging-reducer"
import topicAttachments from "./topic-attachments-reducer"
import topicCount from "./topic-count-reducer"
import topics from "./topic-paging-reducer"
import users from "./user-paging-reducer"

export default combineReducers({
    clusters,
    communities,
    communityParticipants,
    dimensions,
    dimensionCount,
    feed,
    knowledge,
    knowledgeData,
    maps,
    moderationFeed,
    notifications,
    projects,
    reports,
    roles,
    sessions,
    sources,
    stakeholders,
    topics,
    topicAttachments,
    topicCount,
    users,
})
